module.exports = __webpack_public_path__ + "img/streamamg.cdf41dff.png";